export default __webpack_public_path__ + "static/media/send-final-message.c106c5b2.svg";